import { render } from "./LoginLayout.vue?vue&type=template&id=70e82d0d&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=70e82d0d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70e82d0d"

export default script